import useToggle from "../useToggle";
import history from "../../helpers/history";
import { RootState } from "../../states/reducers";
import { getParameterByName } from "../../helpers";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useCallback } from "react";
import { transactionHistoryApi } from "../../apis/transaction";
import { IPaginatedTransactionHistory, ITransactionHistory } from "../../interfaces/transaction";
import { fetchPaginatedTransactionHistory } from "../../states/action_creators/transactionHistory.action_creator";
import { AxiosError } from "axios";

export const useFetchTransactionHistory = () => {
  const dispatch = useDispatch()
  const [error, setError] = useState<Error|null>(null);
  const [fetching, setFetching] = useState(false);
  const { show: showForm, toggle: toggleForm } = useToggle();
  const [sizeSelection, setSizeSelection] = useState(() => +getParameterByName('size')! || 5);
  const [dateFromSelection, setDateFromSelection] = useState(() => getParameterByName('date_from')!);
  const [dateToSelection, setDateToSelection] = useState(() => getParameterByName('date_to')!);
  const { paginatedTransactionHistory } = useSelector((state: RootState) => state.paginatedTransactionHistory)

  const transactionHistory: ITransactionHistory[] = paginatedTransactionHistory?.data!;
  const page = getParameterByName('page') ? parseInt(getParameterByName('page')!) : 1;

  const fetchTransactionHistory = useCallback(async () => {
    try {
      setError(null);
      setFetching(true);
      const payload = { size: sizeSelection, date_from: dateFromSelection, date_to: dateToSelection, page }
      const response = await transactionHistoryApi(payload);
      const paginatedTransactions: IPaginatedTransactionHistory = response.data
      dispatch(fetchPaginatedTransactionHistory(paginatedTransactions))
      setFetching(false);
    } catch (error) {
      const axiosError = error as AxiosError;
      setError(axiosError);
      setFetching(false);
    }
  }, [setError, page, sizeSelection, dateFromSelection, dateToSelection, dispatch]);

  const pageQuery = (page: number = 1) => {
    let query = `?page=${page}`;
    if (sizeSelection) {
      query += `&size=${sizeSelection}`;
    }
    if (dateFromSelection) {
      query += `&date_from=${dateFromSelection}`;
    }
    if (dateToSelection) {
      query += `&date_to=${dateToSelection}`;
    }
    return query;
  };

  const handleFilterTransactions = () => {
    history.push(`/transactions/${pageQuery()}`);
    fetchTransactionHistory()
    toggleForm();
  };

  useEffect(() => {
    fetchTransactionHistory();
  }, [page]);

  return {
    transactionHistory,
    paginatedTransactionHistory,
    error,
    fetching,
    fetchTransactionHistory,
    showForm,
    toggleForm,
    pageQuery,
    dateFromSelection,
    dateToSelection,
    setSizeSelection,
    setDateFromSelection,
    setDateToSelection,
    handleFilterTransactions,
  };
};
